import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { normalizeRole, isMasterByEmail } from '@/modules/shared'
import MemberUserSettingsPage from './MemberUserSettingsPage'
import AffiliateUserSettingsPage from './AffiliateUserSettingsPage'
import MasterUserSettingsPage from './MasterUserSettingsPage'

export default function UserSettingsEntry() {
  const { profile, user } = useAuth()
  const role = normalizeRole(profile?.role || '')
  if (isMasterByEmail(user?.email) || role === 'master') return <MasterUserSettingsPage />
  if (role === 'afiliado') return <AffiliateUserSettingsPage />
  return <MemberUserSettingsPage />
}

